module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("List of Maps")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list_float"
  }, [_vm._v("1")]), _vm._v(" The West Indies Theatre")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list_float"
  }, [_vm._v("2")]), _vm._v(" Grey’s movements on Martinique, March 1794.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list_float"
  }, [_vm._v("3")]), _vm._v(" The Capture of Saint Lucia, April 1794.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list_float"
  }, [_vm._v("4")]), _vm._v(" The Capture of Guadeloupe, April 1794.")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "list_float"
  }, [_vm._v("5")]), _vm._v(" The Loss of Guadeloupe, October-December 1794.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b187188","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/list_of_maps.vue
// module id = 75
// module chunks = 0